/**
 * Traduz uma falha de API para uma frase que um jornalista entende.
 *
 * Várias telas faziam `String(error)` e mandavam para a tela o que saía:
 * "Falha: ApiError: 404 Not Found". Isso não é mensagem de erro — é o nome de
 * uma classe de JavaScript. Não diz o que aconteceu, não diz de quem é a
 * culpa e não diz o que fazer. Medido nesta auditoria em /artigos e /twitter,
 * onde essa string era TODO o conteúdo da tela numa conta nova.
 *
 * Regra: quando o servidor manda um `detail` em português, ele ganha — foi
 * escrito por alguém que sabia o contexto. Quando não manda, a tela diz o que
 * dá para afirmar com honestidade sobre aquele status, e nada além.
 */
import { ApiError } from '@/services/api';

export function motivoLegivel(err: unknown): string {
  if (!(err instanceof ApiError)) {
    return 'Não foi possível falar com o servidor. Verifique a conexão e tente de novo.';
  }
  const detalhe = (err.body as { detail?: unknown } | undefined)?.detail;
  if (typeof detalhe === 'string' && detalhe.trim()) return detalhe.trim();

  switch (err.status) {
    case 401:
      return 'Sua sessão expirou. Entre de novo.';
    case 403:
      return 'Você não tem permissão para ver isto.';
    case 404:
      return 'O recurso pedido não existe (ou ainda não foi configurado).';
    case 409:
      return 'Este pedido conflita com algo que já existe.';
    case 422:
      return 'Os dados enviados não passaram na validação.';
    case 429:
      return 'Pedidos demais em pouco tempo. Aguarde um instante.';
    case 502:
    case 504:
      return 'Um serviço externo não respondeu a tempo.';
    default:
      return err.status >= 500
        ? 'O servidor falhou ao responder. Tente de novo em instantes.'
        : `O servidor recusou o pedido (erro ${err.status}).`;
  }
}
